var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { AfyModal } from "@affinitysystemsgroup/assurehub-ui";
import { FormCreatePlan } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import { FORM_PERCENTAGE_LABEL, FORM_SUBTITLE, FORM_TITLE, } from "../../../constants/plan.constants";
var NOOP = function () { return undefined; };
var MODAL_PROPS = {
    centered: true,
    size: 790,
};
var FORM_CREATE_PLAN_PROPS = {
    initialPercentageBeneficiaries: 100,
    showPercentage: true,
    stepPercentageBeneficiaries: 5,
    formsCompleted: [],
    typeInsuredOption: [],
    onBlurInput: NOOP,
    onChangeCheckBox: NOOP,
    onChangeInput: NOOP,
    onChangeSelect: NOOP,
    onChangeUpload: NOOP,
    onClickAcquire: NOOP,
    onClickCancel: NOOP,
    onClose: NOOP,
    onImage: NOOP,
    onUpload: NOOP,
};
export var ModalCreatePlan = function (props) { return (_jsx(AfyModal, __assign({}, MODAL_PROPS, { opened: props.openModal, onClose: props.onClose }, { children: _jsx(FormCreatePlan, __assign({}, FORM_CREATE_PLAN_PROPS, { openModal: true, OptionList: props.options, dataForm: props.dataForm, labelPercentage: FORM_PERCENTAGE_LABEL, subtitle: FORM_SUBTITLE, title: FORM_TITLE, onNext: props.onNext })) }))); };
